var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhonePe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256px",
    height: "256px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#efefef",
    d: "M 110.5,2.5 C 165.229,-1.55283 207.062,19.4472 236,65.5C 252.45,96.6841 256.117,129.351 247,163.5C 229.106,214.052 193.606,243.552 140.5,252C 87.2016,255.103 46.3683,234.269 18,189.5C 1.90961,159.411 -2.09039,127.745 6,94.5C 22.6556,43.0018 57.4889,12.3351 110.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#683bb7",
    d: "M 195.5,90.5 C 225.815,90.3135 240.315,105.313 239,135.5C 231.819,159.181 215.986,168.681 191.5,164C 172.364,155.914 163.864,141.414 166,120.5C 168.313,110.687 173.48,102.854 181.5,97C 186.147,94.5056 190.814,92.339 195.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f8fc",
    d: "M 195.5,100.5 C 197.924,100.192 200.257,100.526 202.5,101.5C 205.124,106.585 208.124,111.418 211.5,116C 213.81,116.497 216.143,116.663 218.5,116.5C 218.5,118.5 218.5,120.5 218.5,122.5C 216.833,122.5 215.167,122.5 213.5,122.5C 213.5,132.833 213.5,143.167 213.5,153.5C 211.5,153.5 209.5,153.5 207.5,153.5C 207.5,150.5 207.5,147.5 207.5,144.5C 201.524,145.776 196.691,144.11 193,139.5C 191.649,133.928 191.149,128.262 191.5,122.5C 189.833,122.5 188.167,122.5 186.5,122.5C 186.5,120.5 186.5,118.5 186.5,116.5C 193.175,116.666 199.842,116.5 206.5,116C 202.2,111.214 198.533,106.047 195.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e42b9",
    d: "M 49.5,107.5 C 49.1725,112.544 49.5059,117.544 50.5,122.5C 51.1067,122.376 51.44,122.043 51.5,121.5C 56.6203,117.268 61.4537,117.602 66,122.5C 67.4381,130.723 67.9381,139.057 67.5,147.5C 65.8333,147.5 64.1667,147.5 62.5,147.5C 62.6663,140.159 62.4997,132.826 62,125.5C 58.6916,123.007 55.1916,122.841 51.5,125C 50.8742,125.75 50.3742,126.584 50,127.5C 49.5004,134.158 49.3337,140.825 49.5,147.5C 48.1667,147.5 46.8333,147.5 45.5,147.5C 45.5,134.167 45.5,120.833 45.5,107.5C 46.8333,107.5 48.1667,107.5 49.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ab97d4",
    d: "M 49.5,107.5 C 50.1667,112.167 50.8333,116.833 51.5,121.5C 51.44,122.043 51.1067,122.376 50.5,122.5C 49.5059,117.544 49.1725,112.544 49.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c40b9",
    d: "M 13.5,109.5 C 20.5736,109.161 27.5736,109.661 34.5,111C 40.1088,114.277 41.9422,119.11 40,125.5C 38.8783,127.624 37.3783,129.457 35.5,131C 29.9284,132.351 24.2617,132.851 18.5,132.5C 18.5,137.5 18.5,142.5 18.5,147.5C 16.8333,147.5 15.1667,147.5 13.5,147.5C 13.5,134.833 13.5,122.167 13.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeaee",
    d: "M 18.5,113.5 C 22.5138,113.334 26.5138,113.501 30.5,114C 35.7739,117.298 36.7739,121.631 33.5,127C 28.5988,128.325 23.5988,128.825 18.5,128.5C 18.5,123.5 18.5,118.5 18.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e42b9",
    d: "M 80.5,118.5 C 96.898,118.417 102.065,126.084 96,141.5C 86.0509,150.576 78.3842,148.91 73,136.5C 71.9455,128.951 74.4455,122.951 80.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c40b8",
    d: "M 154.5,127.5 C 154.5,129.5 154.5,131.5 154.5,133.5C 148.31,133.177 142.31,133.51 136.5,134.5C 136.245,138.493 137.911,141.326 141.5,143C 145.816,143.469 149.816,142.802 153.5,141C 154.412,143.488 153.412,145.155 150.5,146C 143.441,149.06 137.608,147.56 133,141.5C 129.832,133.242 131.332,126.075 137.5,120C 143.247,117.529 148.413,118.363 153,122.5C 154.009,124.025 154.509,125.692 154.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e43b9",
    d: "M 104.5,119.5 C 105.833,119.5 107.167,119.5 108.5,119.5C 108.351,120.552 108.517,121.552 109,122.5C 113.754,118.936 118.754,118.602 124,121.5C 124.667,122.833 125.333,124.167 126,125.5C 126.5,132.826 126.666,140.159 126.5,147.5C 124.833,147.5 123.167,147.5 121.5,147.5C 121.666,140.492 121.5,133.492 121,126.5C 120.242,124.09 118.575,123.09 116,123.5C 112.726,123.301 110.393,124.634 109,127.5C 108.5,134.158 108.334,140.825 108.5,147.5C 107.167,147.5 105.833,147.5 104.5,147.5C 104.5,138.167 104.5,128.833 104.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e5ed",
    d: "M 140.5,122.5 C 147.013,121.404 150.346,124.071 150.5,130.5C 145.833,130.5 141.167,130.5 136.5,130.5C 136.776,127.281 138.109,124.615 140.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeaee",
    d: "M 82.5,122.5 C 87.772,121.549 91.272,123.549 93,128.5C 93.6667,131.5 93.6667,134.5 93,137.5C 90.5233,143.45 86.3566,144.95 80.5,142C 76.012,134.896 76.6786,128.396 82.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#683ab7",
    d: "M 197.5,122.5 C 200.833,122.5 204.167,122.5 207.5,122.5C 207.666,127.179 207.499,131.845 207,136.5C 203.706,139.311 200.706,138.978 198,135.5C 197.501,131.179 197.334,126.846 197.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9475c8",
    d: "M 154.5,127.5 C 155.468,129.607 155.802,131.941 155.5,134.5C 149.167,134.5 142.833,134.5 136.5,134.5C 142.31,133.51 148.31,133.177 154.5,133.5C 154.5,131.5 154.5,129.5 154.5,127.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePe);
export default __webpack_public_path__ + "static/media/phone-pe.665ffadca1774c3fa62d72e0c868e7dc.svg";
export { ForwardRef as ReactComponent };